import * as yup from "yup";
import { Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "../../../../components/ui/button";
import Common from "../../../../helper/common";
import {
    FormikInput, FormikSearchSelect
} from "../../../../components/formik-components";
import { respEnum, DoubleMin, DoubleMax, DoubleMaximum } from "../../../../constants/appConstant";
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../../../../components/ui/dialog";
import { useNavigate } from "react-router-dom";

const FormikInitialValues = {

};


const formikValidation = yup.object({
    sportId: yup.number().required("Sport is required"),
    fromPoints: yup.number().min(DoubleMin).max(DoubleMaximum).required("From Pointis Required"),
    level: yup.number().min(DoubleMin).max(DoubleMax).required("Level is Required"),
    tillPoints: yup.number().min(DoubleMin).max(DoubleMaximum).required("Till Point is Required"),
});

const AddLevelThreshold = ({ id, onClose, open, setOpen }) => {
    const formikRef = useRef();
    const dialogRef = useRef();
    const [sportList, setSportList] = useState([]);
    const navigate = useNavigate();
    const [isFormikInitialized, setIsFormikInitialized] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            getSports(); 
        };
        fetchData();
    }, []);

    useEffect(() => {
        setIsFormikInitialized(open);
    }, [open]);

    const getSports = async () => {
        return new Promise(async (res) => {
            const response = await Common.ApiService.getInstance().request(
                "GetSportddl"
            );
            const data = [
                { id: null, name: "Select Sport" },
                ...(response?.data ?? []),
            ];

            setSportList(data);
        });
    };

    const onSubmitData = async (d, action) => {
        
        
        if (+d.fromPoints >= +d.tillPoints) {
            alert("Till Point should be greater than From Point.");
            return;
        }

        
        let data = {
            ...d,
            id,
        };
        let response = await Common.ApiService.getInstance().request(
            "AddUpdateSportlevelThreshold",
            data,
            "POST"
        );
        action.setSubmitting(false);
        if (response.status === respEnum.Success) {
            onClose(response.data);
            setOpen(false);
            if (!onClose) {
                navigate("/app/levelthreshold", { replace: true });
            }
        }
    };

    const getDataInfo = async () => {
        
        let response = await Common.ApiService.getInstance().request(
            `GetSportlevelThreshold?id=${id}`
        );
        if (response.status === respEnum.Success && response.data.length > 0) {
            formikRef.current.setValues(response.data[0]);
        }
    };

    useEffect(() => {
        if (id) {
            getDataInfo();
        }
    }, [id]);

    return (
        <div>
            <Dialog open={open} onOpenChange={setOpen}>
                <DialogTrigger asChild>
                    {/*<Button*/}
                    {/*    style={{ marginTop: "-15px" }}*/}
                    {/*    size="icon"*/}
                    {/*    variant="ghost"*/}
                    {/*    className="group p-1 "*/}
                    {/*>*/}
                    {/*    <Icon icon="heroicons:plus-20-solid" className=" h-6 w-6 " />*/}
                    {/*</Button>*/}
                    <Button
                        //onClick={() => setOpen(true)}
                        size="sm"
                        variant="primary"
                        className="flex items-center gap-2"
                    >
                        <Icon icon="heroicons:plus-20-solid" className="h-4 w-4" />
                        Add
                    </Button>
                </DialogTrigger>
                <DialogContent ref={dialogRef} className="max-h-[100vh] overflow-y-auto sm:max-w-[425px]">
                    <DialogHeader>
                        <DialogTitle className="text-base font-medium">
                            {!id ? "Add" : "Update"} Level Thresold
                        </DialogTitle>
                    </DialogHeader>

                    <div className="text-sm text-default-500 space-y-2">
                        <Formik
                            innerRef={formikRef}
                            onSubmit={onSubmitData}
                            initialValues={FormikInitialValues}
                            validationSchema={formikValidation}
                            validateOnChange={false}
                            validateOnBlur={false}
                        >
                            {(formikProps) => (
                                <div className="flex flex-col gap-4">
                                    <FormikSearchSelect
                                        formikProps={formikProps}
                                        name={"sportId"}
                                        placeholder={"Select Sport"}
                                        label={"Sports"}
                                        data={sportList}
                                    />
                                    <FormikInput
                                        formikProps={formikProps}
                                        name={"fromPoints"}
                                        label={"From Points"}
                                        placeholder={"From Points"}
                                        type={"number"}
                                        max={DoubleMaximum}
                                        min={DoubleMin}
                                        onChange={(value) => {
                                            if (value < DoubleMin && value != "") {
                                                formikProps.setFieldValue("fromPoints", DoubleMin);
                                            } else if (value > DoubleMaximum) {
                                                Common.showToast(`From Points cannot be greater than ${DoubleMaximum}`);
                                                formikProps.setFieldValue("fromPoints", "");
                                            } else {
                                                formikProps.setFieldValue("fromPoints", value);
                                            }
                                        }}
                                    />
                                    <FormikInput
                                        formikProps={formikProps}
                                        name={"tillPoints"}
                                        label={"Till Points"}
                                        placeholder={"Till Points"}
                                        type={"number"}
                                        max={DoubleMaximum}
                                        min={DoubleMin}
                                        onChange={(value) => {
                                            if (value < DoubleMin && value != "") {
                                                formikProps.setFieldValue("tillPoints", DoubleMin);
                                            } else if (value > DoubleMaximum) {
                                                Common.showToast(`Till Points cannot be greater than ${DoubleMaximum}`);
                                                formikProps.setFieldValue("tillPoints", "");
                                            } else {
                                                formikProps.setFieldValue("tillPoints", value);
                                            }
                                        }}
                                    />
                                    <FormikInput
                                        formikProps={formikProps}
                                        name={"level"}
                                        label={"Level"}
                                        placeholder={"Level"}
                                        type={"number"}
                                        max={DoubleMax}
                                        min={DoubleMin}
                                        onChange={(value) => {
                                            if (value < DoubleMin && value != "") {
                                                formikProps.setFieldValue("level", DoubleMin);
                                            } else if (value > DoubleMax) {
                                                Common.showToast(`Level cannot be greater than ${DoubleMax}`);
                                                formikProps.setFieldValue("level", "");
                                            } else {
                                                formikProps.setFieldValue("level", value);
                                            }
                                        }}
                                    />
                                </div>
                            )}
                        </Formik>
                    </div>

                    <DialogFooter className="mt-6">
                        <DialogClose asChild>
                            <Button type="button" variant="outline">
                                Close
                            </Button>
                        </DialogClose>
                        {isFormikInitialized && formikRef.current && (
                            <Button
                                type="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    formikRef.current?.handleSubmit();
                                }}
                            >
                                {formikRef.current.isSubmitting ? "Saving..." : !id ? "Add" : "Update"}
                            </Button>
                        )}
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default AddLevelThreshold;
